// frontend/src/pages/Dashboard/Reader/MyComments.js

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import axiosInstance from '../../../utils/axiosConfig';
import { Link } from 'react-router-dom';

const MyComments = () => {
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const [comments, setComments] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchMyComments();
  }, []);

  const fetchMyComments = async () => {
    try {
      const { data } = await axiosInstance.get('/comments/my-comments');
      setComments(data);
    } catch {
      setError('Fehler: Eigene Kommentare konnten nicht geladen werden.');
    }
  };

  return (
    <div className="flex min-h-screen">
      {/* SIDEBAR */}
      <div className={`${sidebarOpen ? 'block' : 'hidden'} sm:block bg-gray-100 w-64 p-4`}>
        {/* Schliessen-Button (mobil) */}
        <button onClick={() => setSidebarOpen(false)} className="sm:hidden mb-4">
          <XMarkIcon className="w-6 h-6 text-gray-600" />
        </button>

        {/* Zurück-Button */}
        <button
          onClick={() => navigate(-1)}
          className="bg-primary text-white w-full text-left px-4 py-2 rounded hover:bg-orange-600 mb-2"
        >
          ← Zurück
        </button>

        {/* Reader Links */}
        <Link
          to="/reader/dashboard"
          className="block bg-primary text-white px-4 py-2 rounded hover:bg-orange-600 mb-2"
        >
          Leser-Dashboard
        </Link>
        <Link
          to="/reader/my-comments"
          className="block bg-primary text-white px-4 py-2 rounded hover:bg-orange-600"
        >
          Meine Kommentare
        </Link>
      </div>

      {/* MAIN CONTENT */}
      <div className="flex-1 p-4">
        {/* Menü öffnen (mobil) */}
        <button onClick={() => setSidebarOpen(true)} className="sm:hidden mb-4">
          <Bars3Icon className="w-6 h-6 text-gray-600" />
        </button>

        <motion.div className="py-8" initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
          <h1 className="text-3xl font-heading text-primary mb-6">Meine Kommentare</h1>
          {error && <div className="bg-red-100 text-red-700 p-2 mb-4">{error}</div>}
          {comments.length === 0 ? (
            <p>Keine Kommentare gefunden.</p>
          ) : (
            <div className="space-y-4">
              {comments.map((c) => (
                <div key={c._id} className="border-b pb-2">
                  <p>
                    <strong>Artikel:</strong> {c.article?.title}
                  </p>
                  <p>
                    <strong>Kommentar:</strong> {c.text}
                  </p>
                  <span className="text-sm text-gray-400">
                    {new Date(c.createdAt).toLocaleString()}
                  </span>
                </div>
              ))}
            </div>
          )}
        </motion.div>
      </div>
    </div>
  );
};

export default MyComments;
